import { Route, Routes } from 'react-router-dom';

import AuthIntegrationCallback from './integration';
import AuthLoginCallback from './login';

export default function AuthCallback() {
  return (
    <Routes>
      <Route path="google/callback" element={<AuthLoginCallback />} />
      <Route path=":provider/callback" element={<AuthIntegrationCallback />} />
    </Routes>
  );
}
